export default __webpack_public_path__ + "static/media/sync_fail_icon.d4a05ad4.svg";